// extracted by mini-css-extract-plugin
module.exports = {"logout":"Logout_logout__rMD6w","logout__text":"Logout_logout__text__3eLCp"};